import React from 'react';

import * as S from './styles';

const UtmBadge: React.FC = () => {
  return (
    <S.Wrapper>
      <S.Text>UTM</S.Text>
    </S.Wrapper>
  );
};

export default UtmBadge;
